import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { MembershipPlanModel } from 'src/app/admin-panel/models/business/membership-plan.model';
import { AddOrEditMembershipPlansComponent } from './add-or-edit-membership-plans/add-or-edit-membership-plans.component';
import { DeleteMembershipPlansComponent } from './delete-membership-plans/delete-membership-plans.component';

@Component({
  selector: 'app-membership-plans',
  templateUrl: './membership-plans.component.html',
  styleUrls: ['./membership-plans.component.scss']
})
export class MembershipPlansComponent implements OnInit {
  //#region Fields
  public membershipPlanList: Array<MembershipPlanModel>
  public membershipPlan1: MembershipPlanModel;
  public membershipPlan2: MembershipPlanModel;
  public membershipPlan3: MembershipPlanModel;
  public membershipPlan4: MembershipPlanModel;
  public membershipPlan5: MembershipPlanModel;
  public membershipPlan6: MembershipPlanModel;
  public membershipPlan7: MembershipPlanModel;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService
  ) {
    this.membershipPlanList = new Array<MembershipPlanModel>();
    this.membershipPlan1 = new MembershipPlanModel();
    this.membershipPlan1.Id = "1";
    this.membershipPlan1.Name = "Бесплатен пакет";
    this.membershipPlan1.Price = "0 ден";
    this.membershipPlan1.Title = "Времетраење:1 месец";
    this.membershipPlan1.Description = "Бизнис корисници";
    this.membershipPlan1.NumberOfVenues = "1";

    this.membershipPlan2 = new MembershipPlanModel();
    this.membershipPlan2.Id = "2";
    this.membershipPlan2.Name = "Основен пакет";
    this.membershipPlan2.Price = "3000 ден";
    this.membershipPlan2.Title = "Web платформа месечна сума";
    this.membershipPlan2.Description = "Бизнис корисници";
    this.membershipPlan2.NumberOfVenues = "1-2";

    this.membershipPlan3 = new MembershipPlanModel();
    this.membershipPlan3.Id = "3";
    this.membershipPlan3.Name = "Стандард пакет";
    this.membershipPlan3.Price = "3600 ден";
    this.membershipPlan3.Title = "Web платформа месечна сума";
    this.membershipPlan3.Description = "Бизнис корисници";
    this.membershipPlan3.NumberOfVenues = "3-5";

    this.membershipPlan4 = new MembershipPlanModel();
    this.membershipPlan4.Id = "4";
    this.membershipPlan4.Name = "Премиум пакет";
    this.membershipPlan4.Price = "7200 ден";
    this.membershipPlan4.Title = "Web платформа месечна сума";
    this.membershipPlan4.Description = "Бизнис корисници";
    this.membershipPlan4.NumberOfVenues = "6-13";

    this.membershipPlan5 = new MembershipPlanModel();
    this.membershipPlan5.Id = "5";
    this.membershipPlan5.Name = "Златен пакет";
    this.membershipPlan5.Price = "10 000 ден";
    this.membershipPlan5.Title = "Web платформа месечна сума";
    this.membershipPlan5.Description = "Бизнис корисници";
    this.membershipPlan5.NumberOfVenues = "13-20";

    this.membershipPlan6 = new MembershipPlanModel();
    this.membershipPlan6.Id = "6";
    this.membershipPlan6.Name = "Платиум пакет";
    this.membershipPlan6.Price = "15 000 ден";
    this.membershipPlan6.Title = "Web платформа месечна сума";
    this.membershipPlan6.Description = "Бизнис корисници";
    this.membershipPlan6.NumberOfVenues = "20-50";

    this.membershipPlan7 = new MembershipPlanModel();
    this.membershipPlan7.Id = "7";
    this.membershipPlan7.Name = "All-in пакет";
    this.membershipPlan7.Price = "20 000 ден";
    this.membershipPlan7.Title = "Web платформа месечна сума";
    this.membershipPlan7.Description = "Бизнис корисници";
    this.membershipPlan7.NumberOfVenues = "50+";

    this.membershipPlanList.push(this.membershipPlan1)
    this.membershipPlanList.push(this.membershipPlan2)
    this.membershipPlanList.push(this.membershipPlan3)
    this.membershipPlanList.push(this.membershipPlan4)
    this.membershipPlanList.push(this.membershipPlan5)
    this.membershipPlanList.push(this.membershipPlan6)
    this.membershipPlanList.push(this.membershipPlan7)
  }

  ngOnInit(): void {
  }
  //#endregion
  //#region Public Methods
 
  addNewMembershipPlans() {
    const ref = this.dialogService.open(AddOrEditMembershipPlansComponent, {
      header: 'Add Membership Plan',
      width: '300px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  editMembershipPlan(membershipPlanId: string , model : MembershipPlanModel) {
    const ref = this.dialogService.open(AddOrEditMembershipPlansComponent, {
      data: {
        id: membershipPlanId,
        model:model
      },
      header: 'Edit Membership Plan',
      width: '300px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  deleteMembershipPlan(membershipPlanId: string) {
    const ref = this.dialogService.open(DeleteMembershipPlansComponent, {
      data: {
        id: membershipPlanId
      },
      header: 'Delete Membership Plan',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  loadMoreMembershipPlans(){

  }
  //#endregion
  //#Private Methods
  //#endregion
}
